import "./resource";
import { StripeContract, StripeContractStatus, MonextContract } from "../../typings/payment";

class ContractService {
    public static $inject: string[] = [
        "$log",
        "$q",
        "contractResource"
    ];

    protected isStripeContractActivated: boolean;
    protected contracts: StripeContract[] | MonextContract[];

    constructor(
        private $log: ng.ILogService,
        private $q: ng.IQService,
        private contractResource
    ) { }

    public get(organizationId, type, providerType) {
        return this.contractResource()
            .get({ id: organizationId, company_type: type, provider: providerType })
            .$promise
            .then(({ data: contracts }: { data: StripeContract[] | MonextContract[] }) => {
                this.contracts = contracts;
                this.isStripeContractActivated = contracts?.some(
                    contract => contract.status === StripeContractStatus.Activated
                );
                return this.$q.resolve(contracts);
            })
            .catch(error => {
                this.$log.error("Error while getting contracts organization", error);
                return this.$q.reject(error);
            });
    }

    public getMonext(organizationId) {
        return this.contractResource()
            .get({ id: organizationId, provider: "monext" })
            .$promise
            .then(({ data: contracts }: { data: MonextContract[] }) => {
                return this.$q.resolve(contracts);
            })
            .catch(error => {
                this.$log.error("Error while getting contracts organization", error);
                return this.$q.reject(error);
            });
    }
}

angular
    .module("thor.core.contract.service", [
        "thor.core.contract.resource"
    ])
    .service("contractService", ContractService);
